import React, { useEffect } from 'react';
import { useDashboard } from '../../contexts/DashboardContext';
import ProductImage from '../common/ProductImage';
import PackageImage from '../common/PackageImage';
import AddonImage from '../common/AddonImage';

const ProductModals = () => {
  const {
    API,
    addEditPricingTier,
    addPricingTier,
    addProduct,
    addonProducts,
    axios,
    createObjectURL,
    createResponse,
    editPricingTier,
    editProductForm,
    editShowPricingTiers,
    editingAddon,
    editingPackage,
    editingProduct,
    isNaN,
    isSelected,
    newAddon,
    newPackage,
    newPricingTier,
    newProduct,
    packageProductSearch,
    packages,
    products,
    selectedItem,
    selectedItems,
    setAddonProducts,
    setEditPricingTier,
    setEditProductForm,
    setEditShowPricingTiers,
    setEditingAddon,
    setEditingPackage,
    setEditingProduct,
    setNewAddon,
    setNewPackage,
    setNewPricingTier,
    setNewProduct,
    setPackageProductSearch,
    setPackageSearchIndex,
    setPackages,
    setShowAddAddon,
    setShowAddPackage,
    setShowAddProduct,
    setShowEditProduct,
    setShowPricingTiers,
    setUploadingProductImage,
    showAddAddon,
    showAddPackage,
    showAddProduct,
    showEditProduct,
    showPricingTiers,
    showToast,
    updateProduct,
    uploadError,
    uploadResponse,
    uploadingProductImage,
  } = useDashboard();

  // Populate form when editing a package
  useEffect(() => {
    if (editingPackage && showAddPackage) {
      setNewPackage({
        name: editingPackage.name || '',
        description: editingPackage.description || '',
        product_ids: editingPackage.product_ids || [],
        discount_percentage: editingPackage.discount_percentage || 0,
        discount_amount: editingPackage.discount_amount || 0,
        square_footage: editingPackage.square_footage || '',
        active: editingPackage.is_active !== false,
        image: null,
      });
    }
  }, [editingPackage, showAddPackage]);

  // Populate form when editing an addon
  useEffect(() => {
    if (editingAddon && showAddAddon) {
      setNewAddon({
        name: editingAddon.name || '',
        description: editingAddon.description || '',
        base_price: editingAddon.base_price || 0,
        duration_minutes: editingAddon.duration_minutes || 0,
        linked_product_ids: editingAddon.linked_product_ids || [],
        active: editingAddon.is_active !== false,
        image: null,
      });
    }
  }, [editingAddon, showAddAddon]);

  return (
    <>
        {/* Add Product Modal */}
        {showAddProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-[150]">
            <div className="clara-card w-full max-w-[95vw] lg:max-w-4xl rounded-lg overflow-hidden" style={{ border: 'none', outline: 'none' }}>
              <div className="modal-header-fixed px-8 py-6" style={{ backgroundColor: '#374051' }}>
                <h3 className="clara-heading-3 text-white" style={{ margin: 0, color: '#ffffff' }}>Add Product/Service</h3>
              </div>
              <div className="modal-content-scroll p-8">
                {/* Two-column layout for desktop */}
                <div className="flex flex-col lg:flex-row lg:gap-8">
                  {/* Left Column - Basic Info */}
                  <div className="flex-1 space-y-4">
                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Name</label>
                      <input
                        type="text"
                        value={newProduct.name}
                        onChange={(e) => setNewProduct({...newProduct, name: e.target.value})}
                        className="clara-input w-full"
                      />
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Thumbnail Image</label>
                      {newProduct.image && (
                        <div className="mb-3">
                          <img 
                            src={URL.createObjectURL(newProduct.image)} 
                            alt="Product preview" 
                            className="w-32 h-32 object-cover rounded-lg border"
                            style={{ borderColor: 'var(--clara-border)' }}
                          />
                          <button
                            type="button"
                            onClick={() => setNewProduct({...newProduct, image: null})}
                            className="mt-2 text-xs text-red-600 hover:text-red-700"
                          >
                            Remove image
                          </button>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            setNewProduct({...newProduct, image: e.target.files[0]});
                          }
                        }}
                        className="clara-input w-full"
                      />
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Description</label>
                      <textarea
                        value={newProduct.description}
                        onChange={(e) => setNewProduct({...newProduct, description: e.target.value})}
                        className="clara-input w-full"
                        rows="3"
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>
                          Base Price ($)
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          value={newProduct.price}
                          onChange={(e) => setNewProduct({...newProduct, price: e.target.value})}
                          className="clara-input w-full"
                        />
                      </div>
                      <div>
                        <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Duration (min)</label>
                        <input
                          type="number"
                          value={newProduct.duration_minutes}
                          onChange={(e) => setNewProduct({...newProduct, duration_minutes: e.target.value})}
                          className="clara-input w-full"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Category</label>
                      <select
                        value={newProduct.category}
                        onChange={(e) => setNewProduct({...newProduct, category: e.target.value})}
                        className="clara-input w-full"
                      >
                        <option value="Photography">Photography</option>
                        <option value="Videography">Videography</option>
                        <option value="Virtual Tour">Virtual Tour</option>
                        <option value="Drone">Drone</option>
                        <option value="Staging">Staging</option>
                        <option value="Marketing">Marketing</option>
                        <option value="Floor Plans">Floor Plans</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div>
                      <label className="flex items-center justify-between">
                        <span className="clara-body-sm font-medium" style={{ color: 'var(--clara-secondary)' }}>Active</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={newProduct.active}
                            onChange={(e) => setNewProduct({...newProduct, active: e.target.checked})}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </label>
                    </div>
                  </div>

                  {/* Right Column - Pricing Tiers */}
                  <div className="lg:w-96 mt-6 lg:mt-0">
                    <div className="mb-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={showPricingTiers}
                          onChange={(e) => setShowPricingTiers(e.target.checked)}
                          className="mr-2"
                        />
                        <span className="clara-body-sm font-medium" style={{ color: 'var(--clara-secondary)' }}>
                          Enable Square Footage Based Pricing
                        </span>
                      </label>
                    </div>

                    {showPricingTiers && (
                      <div className="border rounded-lg p-4" style={{ borderColor: 'var(--clara-border)' }}>
                        <h5 className="clara-body font-medium mb-3" style={{ color: 'var(--clara-primary)' }}>
                          Square Footage Pricing Tiers
                        </h5>
                        
                        {/* Existing Tiers */}
                        {newProduct.pricing_tiers.length > 0 && (
                          <div className="space-y-2 mb-4 max-h-48 overflow-y-auto">
                            {newProduct.pricing_tiers.map((tier, index) => (
                              <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                                <span className="clara-body-sm">
                                  {(tier.min_sqft || 0).toLocaleString()} - {(tier.max_sqft || 0).toLocaleString()} sq ft: ${tier.price} ({tier.duration_minutes || 0} min)
                                </span>
                                <button
                                  onClick={() => removePricingTier(index)}
                                  className="text-red-600 hover:text-red-700 text-sm"
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Add New Tier */}
                        <div className="grid grid-cols-2 gap-2 mb-3">
                          <input
                            type="number"
                            placeholder="Min Sq Ft"
                            value={newPricingTier.min_sqft}
                            onChange={(e) => setNewPricingTier({...newPricingTier, min_sqft: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            placeholder="Max Sq Ft"
                            value={newPricingTier.max_sqft}
                            onChange={(e) => setNewPricingTier({...newPricingTier, max_sqft: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            step="0.01"
                            placeholder="Price ($)"
                            value={newPricingTier.price}
                            onChange={(e) => setNewPricingTier({...newPricingTier, price: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            placeholder="Duration (min)"
                            value={newPricingTier.duration_minutes}
                            onChange={(e) => setNewPricingTier({...newPricingTier, duration_minutes: e.target.value})}
                            className="clara-input text-sm"
                          />
                        </div>
                        <button
                          onClick={addPricingTier}
                          disabled={!newPricingTier.min_sqft || !newPricingTier.max_sqft || !newPricingTier.price || !newPricingTier.duration_minutes}
                          className="clara-btn-secondary w-full py-2 text-sm"
                        >
                          Add Pricing Tier
                        </button>

                        <div className="mt-3 p-3 bg-blue-50 rounded">
                          <p className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>
                            <strong>Example:</strong> 0-2000 sq ft = $100 (60 min)
                          </p>
                        </div>
                      </div>
                    )}

                    {!showPricingTiers && (
                      <div className="border border-dashed border-gray-300 rounded-lg p-6 text-center">
                        <p className="text-sm text-gray-500">
                          Enable pricing tiers to charge different rates based on property square footage
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer-fixed px-8 py-6 border-t" style={{ borderColor: 'var(--clara-border)' }}>
                <div className="flex space-x-4">
                  <button
                    onClick={addProduct}
                    disabled={uploadingProductImage}
                    className="flex-1 clara-btn-primary py-3 flex items-center justify-center gap-2"
                  >
                    {uploadingProductImage ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Uploading Image...
                      </>
                    ) : 'Add Product'}
                  </button>
                  <button
                    onClick={() => {
                      setShowAddProduct(false);
                      setNewProduct({ name: '', description: '', price: '', pricing_tiers: [], duration_minutes: '', category: 'Photography', active: true });
                      setShowPricingTiers(false);
                      setNewPricingTier({ min_sqft: '', max_sqft: '', price: '', duration_minutes: '' });
                    }}
                    className="flex-1 clara-btn-secondary py-3"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Edit Product Modal */}
        {showEditProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-[150]">
            <div className="clara-card w-full max-w-[95vw] lg:max-w-4xl rounded-lg overflow-hidden" style={{ border: 'none', outline: 'none' }}>
              <div className="modal-header-fixed px-8 py-6" style={{ backgroundColor: '#374051' }}>
                <h3 className="clara-heading-3 text-white" style={{ margin: 0, color: '#ffffff' }}>Edit Product/Service</h3>
              </div>
              <div className="modal-content-scroll p-8">
                {/* Two-column layout for desktop */}
                <div className="flex flex-col lg:flex-row lg:gap-8">
                  {/* Left Column - Basic Info */}
                  <div className="flex-1 space-y-4">
                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Name</label>
                      <input
                        type="text"
                        value={editProductForm.name}
                        onChange={(e) => setEditProductForm({...editProductForm, name: e.target.value})}
                        className="clara-input w-full"
                      />
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Thumbnail Image</label>
                      {(editProductForm.image || editingProduct?.image_id) && (
                        <div className="mb-3">
                          {editProductForm.image ? (
                            <div>
                              <img 
                                src={URL.createObjectURL(editProductForm.image)} 
                                alt="Product preview" 
                                className="w-32 h-32 object-cover rounded-lg border"
                                style={{ borderColor: 'var(--clara-border)' }}
                              />
                              <button
                                type="button"
                                onClick={() => setEditProductForm({...editProductForm, image: null})}
                                className="mt-2 text-xs text-red-600 hover:text-red-700"
                              >
                                Remove image
                              </button>
                            </div>
                          ) : editingProduct?.image_id ? (
                            <div>
                              <ProductImage productId={editingProduct.id} imageName="Current thumbnail" size="w-32 h-32" />
                            </div>
                          ) : null}
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            setEditProductForm({...editProductForm, image: e.target.files[0]});
                          }
                        }}
                        className="clara-input w-full"
                      />
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Description</label>
                      <textarea
                        value={editProductForm.description}
                        onChange={(e) => setEditProductForm({...editProductForm, description: e.target.value})}
                        className="clara-input w-full"
                        rows="3"
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>
                          Base Price ($)
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          value={editProductForm.price}
                          onChange={(e) => setEditProductForm({...editProductForm, price: e.target.value})}
                          className="clara-input w-full"
                        />
                      </div>
                      <div>
                        <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Duration (min)</label>
                        <input
                          type="number"
                          value={editProductForm.duration_minutes}
                          onChange={(e) => setEditProductForm({...editProductForm, duration_minutes: e.target.value})}
                          className="clara-input w-full"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Category</label>
                      <select
                        value={editProductForm.category}
                        onChange={(e) => setEditProductForm({...editProductForm, category: e.target.value})}
                        className="clara-input w-full"
                      >
                        <option value="Photography">Photography</option>
                        <option value="Videography">Videography</option>
                        <option value="Virtual Tour">Virtual Tour</option>
                        <option value="Drone">Drone</option>
                        <option value="Staging">Staging</option>
                        <option value="Marketing">Marketing</option>
                        <option value="Floor Plans">Floor Plans</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div>
                      <label className="flex items-center justify-between">
                        <span className="clara-body-sm font-medium" style={{ color: 'var(--clara-secondary)' }}>Active</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={editProductForm.active}
                            onChange={(e) => {
                              setEditProductForm({...editProductForm, active: e.target.checked});
                            }}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </label>
                    </div>
                  </div>

                  {/* Right Column - Pricing Tiers */}
                  <div className="lg:w-96 mt-6 lg:mt-0">
                    <div className="mb-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={editShowPricingTiers}
                          onChange={(e) => setEditShowPricingTiers(e.target.checked)}
                          className="mr-2"
                        />
                        <span className="clara-body-sm font-medium" style={{ color: 'var(--clara-secondary)' }}>
                          Enable Square Footage Based Pricing
                        </span>
                      </label>
                    </div>

                    {editShowPricingTiers && (
                      <div className="border rounded-lg p-4" style={{ borderColor: 'var(--clara-border)' }}>
                        <h5 className="clara-body font-medium mb-3" style={{ color: 'var(--clara-primary)' }}>
                          Square Footage Pricing Tiers
                        </h5>
                        
                        {/* Existing Tiers */}
                        {editProductForm.pricing_tiers.length > 0 && (
                          <div className="space-y-2 mb-4 max-h-48 overflow-y-auto">
                            {editProductForm.pricing_tiers.map((tier, index) => (
                              <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                                <span className="clara-body-sm">
                                  {(tier.min_sqft || 0).toLocaleString()} - {(tier.max_sqft || 0).toLocaleString()} sq ft: ${tier.price} ({tier.duration_minutes || 0} min)
                                </span>
                                <button
                                  onClick={() => removeEditPricingTier(index)}
                                  className="text-red-600 hover:text-red-700 text-sm"
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Add New Tier */}
                        <div className="grid grid-cols-2 gap-2 mb-3">
                          <input
                            type="number"
                            placeholder="Min Sq Ft"
                            value={editPricingTier.min_sqft}
                            onChange={(e) => setEditPricingTier({...editPricingTier, min_sqft: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            placeholder="Max Sq Ft"
                            value={editPricingTier.max_sqft}
                            onChange={(e) => setEditPricingTier({...editPricingTier, max_sqft: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            step="0.01"
                            placeholder="Price ($)"
                            value={editPricingTier.price}
                            onChange={(e) => setEditPricingTier({...editPricingTier, price: e.target.value})}
                            className="clara-input text-sm"
                          />
                          <input
                            type="number"
                            placeholder="Duration (min)"
                            value={editPricingTier.duration_minutes}
                            onChange={(e) => setEditPricingTier({...editPricingTier, duration_minutes: e.target.value})}
                            className="clara-input text-sm"
                          />
                        </div>
                        <button
                          onClick={addEditPricingTier}
                          disabled={!editPricingTier.min_sqft || !editPricingTier.max_sqft || !editPricingTier.price || !editPricingTier.duration_minutes}
                          className="clara-btn-secondary w-full py-2 text-sm"
                        >
                          Add Pricing Tier
                        </button>

                        <div className="mt-3 p-3 bg-blue-50 rounded">
                          <p className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>
                            <strong>Example:</strong> 0-2000 sq ft = $100 (60 min)
                          </p>
                        </div>
                      </div>
                    )}

                    {!editShowPricingTiers && (
                      <div className="border border-dashed border-gray-300 rounded-lg p-6 text-center">
                        <p className="text-sm text-gray-500">
                          Enable pricing tiers to charge different rates based on property square footage
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer-fixed px-8 py-6 border-t" style={{ borderColor: 'var(--clara-border)' }}>
                <div className="flex space-x-4">
                  <button
                    onClick={updateProduct}
                    disabled={uploadingProductImage}
                    className="flex-1 clara-btn-primary py-3 flex items-center justify-center gap-2"
                  >
                    {uploadingProductImage ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Uploading Image...
                      </>
                    ) : 'Update Product'}
                  </button>
                  <button
                    onClick={() => {
                      setShowEditProduct(false);
                      setEditingProduct(null);
                      setEditShowPricingTiers(false);
                      setEditPricingTier({ min_sqft: '', max_sqft: '', price: '', duration_minutes: '' });
                    }}
                    className="flex-1 clara-btn-secondary py-3"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Create/Edit Package Modal */}
        {showAddPackage && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[150]"
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                setShowAddPackage(false);
                setEditingPackage(null);
                setNewPackage({ name: '', description: '', product_ids: [], discount_percentage: 0 });
              }
            }}
            tabIndex={-1}
            ref={(el) => el && el.focus()}
          >
            <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 bg-gray-700 flex justify-between items-center sticky top-0">
                <h3 className="text-lg font-semibold text-white">
                  {editingPackage ? 'Edit Package' : 'Create Package'}
                </h3>
                <button
                  onClick={() => {
                    setShowAddPackage(false);
                    setEditingPackage(null);
                    setNewPackage({ name: '', description: '', product_ids: [], discount_percentage: 0 });
                  }}
                  className="text-white hover:text-gray-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <form onSubmit={async (e) => {
                e.preventDefault();
                try {
                  let packageId = editingPackage?.id;
                  
                  // First create/update the package
                  if (editingPackage) {
                    await axios.put(`${API}/settings/packages/${editingPackage.id}`, {
                      name: newPackage.name,
                      description: newPackage.description,
                      product_ids: newPackage.product_ids,
                      discount_percentage: newPackage.discount_percentage,
                      is_active: newPackage.active
                    });
                  } else {
                    const response = await axios.post(`${API}/settings/packages`, {
                      name: newPackage.name,
                      description: newPackage.description,
                      product_ids: newPackage.product_ids,
                      discount_percentage: newPackage.discount_percentage,
                      is_active: newPackage.active
                    });
                    packageId = response.data.id;
                  }
                  
                  // Then upload image if selected
                  if (newPackage.image && packageId) {
                    console.log('Uploading image for package:', packageId);
                    setUploadingProductImage(true);
                    const formData = new FormData();
                    formData.append('file', newPackage.image);
                    try {
                      const uploadResponse = await axios.post(`${API}/settings/packages/${packageId}/upload-image`, formData, {
                        headers: { 
                          'Content-Type': 'multipart/form-data'
                        }
                      });
                      console.log('Image upload response:', uploadResponse.data);
                    } finally {
                      setUploadingProductImage(false);
                    }
                  }
                  
                  // Refresh packages list
                  const packagesResponse = await axios.get(`${API}/settings/packages`);
                  setPackages(packagesResponse.data);
                  
                  showToast(editingPackage ? 'Package updated successfully!' : 'Package created successfully!', 'success');
                  setShowAddPackage(false);
                  setEditingPackage(null);
                  setNewPackage({ name: '', description: '', product_ids: [], discount_percentage: 0, discount_amount: 0, square_footage: 2000, image: null, image_id: null, active: false });
                } catch (error) {
                  console.error('Error saving package:', error);
                  console.error('Error details:', error.response?.data);
                  setUploadingProductImage(false);
                  showToast('Failed to save package: ' + (error.response?.data?.detail || error.message), 'error');
                }
              }} className="p-6">
                
                {/* Two-column layout for desktop */}
                <div className="flex flex-col lg:flex-row lg:gap-8">
                  {/* Left Column - Basic Info */}
                  <div className="flex-1 space-y-6">
                    {/* Package Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Package Name *</label>
                      <input
                        type="text"
                        required
                        value={newPackage.name}
                        onChange={(e) => setNewPackage({...newPackage, name: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="e.g., Premium Media Package"
                      />
                    </div>

                    {/* Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                      <textarea
                        value={newPackage.description}
                        onChange={(e) => setNewPackage({...newPackage, description: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        rows="3"
                        placeholder="Brief description of what's included..."
                      />
                    </div>

                    {/* Package Image */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Package Image</label>
                      
                      {/* Image Preview */}
                      {(newPackage.image || editingPackage?.image_id) && (
                        <div className="mb-3">
                          {newPackage.image ? (
                            <div>
                              <img 
                                src={URL.createObjectURL(newPackage.image)} 
                                alt="Package preview" 
                                className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                                onError={(e) => {
                                  console.error('Failed to create image preview');
                                }}
                              />
                              <button
                                type="button"
                                onClick={() => setNewPackage({...newPackage, image: null})}
                                className="mt-2 text-xs text-red-600 hover:text-red-700"
                              >
                                Remove image
                              </button>
                            </div>
                          ) : editingPackage?.image_id ? (
                            <div>
                              <PackageImage packageId={editingPackage.id} imageName="Current package" size="w-32 h-32" />
                            </div>
                          ) : null}
                        </div>
                      )}
                      
                      <input
                        type="file"
                        accept="image/*"
                        id="package-image-input"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            const file = e.target.files[0];
                            setNewPackage({...newPackage, image: file});
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      />
                      {newPackage.image && (
                        <p className="text-xs text-green-600 mt-1">✓ {newPackage.image.name}</p>
                      )}
                    </div>

                    {/* Square Footage Selection */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Calculate Price for Property Size</label>
                      <select
                        value={newPackage.square_footage}
                        onChange={(e) => setNewPackage({...newPackage, square_footage: parseInt(e.target.value)})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000].map(sqft => (
                          <option key={sqft} value={sqft}>{sqft.toLocaleString()} sqft</option>
                        ))}
                      </select>
                      <p className="text-xs text-gray-500 mt-1">
                        Pricing will be calculated based on this property size
                      </p>
                    </div>

                    {/* Active Toggle */}
                    <div>
                      <label className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-700">Active</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={newPackage.active}
                            onChange={(e) => setNewPackage({...newPackage, active: e.target.checked})}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </label>
                    </div>
                  </div>

                  {/* Right Column - Product Selection & Pricing */}
                  <div className="lg:w-96 mt-6 lg:mt-0 space-y-4">
                    {/* Product Selection - Searchable */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Add Products & Add-ons</label>
                      
                      {/* Search Input */}
                      <div className="relative">
                        <input
                          type="text"
                          value={packageProductSearch}
                          onChange={(e) => {
                            setPackageProductSearch(e.target.value);
                            setPackageSearchIndex(0); // Reset selection on search change
                          }}
                          onKeyDown={(e) => {
                            if (!packageProductSearch) return;
                            
                            // Get filtered items for keyboard navigation
                            const sqft = newPackage.square_footage || 2000;
                            const filteredProducts = products
                              .filter(p => p.is_active !== false)
                              .filter(p => !newPackage.product_ids.includes(p.id))
                              .filter(p => p.name.toLowerCase().includes(packageProductSearch.toLowerCase()))
                              .map(p => ({ ...p, type: 'product' }));
                            const filteredAddons = addonProducts
                              .filter(a => a.is_active !== false)
                              .filter(a => !newPackage.product_ids.includes(a.id))
                              .filter(a => a.name.toLowerCase().includes(packageProductSearch.toLowerCase()))
                              .map(a => ({ ...a, type: 'addon', price: a.base_price }));
                            const allItems = [...filteredProducts, ...filteredAddons];
                            
                            if (allItems.length === 0) return;
                            
                            if (e.key === 'ArrowDown') {
                              e.preventDefault();
                              setPackageSearchIndex(prev => Math.min(prev + 1, allItems.length - 1));
                            } else if (e.key === 'ArrowUp') {
                              e.preventDefault();
                              setPackageSearchIndex(prev => Math.max(prev - 1, 0));
                            } else if (e.key === 'Enter') {
                              e.preventDefault();
                              const selectedItem = allItems[packageSearchIndex];
                              if (selectedItem) {
                                setNewPackage({
                                  ...newPackage,
                                  product_ids: [...newPackage.product_ids, selectedItem.id]
                                });
                                setPackageProductSearch('');
                                setPackageSearchIndex(0);
                              }
                            } else if (e.key === 'Escape') {
                              setPackageProductSearch('');
                              setPackageSearchIndex(0);
                            }
                          }}
                          placeholder="Search products or add-ons..."
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 pr-8"
                        />
                        {packageProductSearch && (
                          <button
                            type="button"
                            onClick={() => {
                              setPackageProductSearch('');
                              setPackageSearchIndex(0);
                            }}
                            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        )}
                      </div>
                      
                      {/* Search Results Dropdown - Both Products and Add-ons */}
                      {packageProductSearch && (
                        <div className="border border-gray-200 rounded-lg mt-1 max-h-48 overflow-y-auto bg-white shadow-lg">
                          {(() => {
                            const sqft = newPackage.square_footage || 2000;
                            
                            // Filter main products
                            const filteredProducts = products
                              .filter(p => p.is_active !== false)
                              .filter(p => !newPackage.product_ids.includes(p.id))
                              .filter(p => p.name.toLowerCase().includes(packageProductSearch.toLowerCase()))
                              .map(p => ({ ...p, type: 'product' }));
                            
                            // Filter add-on products
                            const filteredAddons = addonProducts
                              .filter(a => a.is_active !== false)
                              .filter(a => !newPackage.product_ids.includes(a.id))
                              .filter(a => a.name.toLowerCase().includes(packageProductSearch.toLowerCase()))
                              .map(a => ({ ...a, type: 'addon', price: a.base_price }));
                            
                            const allItems = [...filteredProducts, ...filteredAddons];
                            
                            if (allItems.length === 0) {
                              return <p className="text-sm text-gray-500 text-center py-3">No matching products or add-ons</p>;
                            }
                            
                            return allItems.map((item, index) => {
                              let displayPrice = item.price;
                              if (item.type === 'product' && item.pricing_tiers && item.pricing_tiers.length > 0) {
                                const tier = item.pricing_tiers.find(t => 
                                  sqft >= (t.min_sqft || 0) && sqft <= (t.max_sqft || Infinity)
                                );
                                if (tier) displayPrice = tier.price;
                              }
                              
                              const isSelected = index === packageSearchIndex;
                              
                              return (
                                <button
                                  key={item.id}
                                  type="button"
                                  onClick={() => {
                                    setNewPackage({
                                      ...newPackage,
                                      product_ids: [...newPackage.product_ids, item.id]
                                    });
                                    setPackageProductSearch('');
                                    setPackageSearchIndex(0);
                                  }}
                                  className={`w-full flex items-center justify-between p-2 text-left border-b border-gray-100 last:border-b-0 ${
                                    isSelected ? 'bg-blue-100' : 'hover:bg-blue-50'
                                  }`}
                                >
                                  <div className="flex items-center gap-2">
                                    <span className="text-sm font-medium text-gray-900">{item.name}</span>
                                    {item.type === 'addon' && (
                                      <span className="text-xs px-1.5 py-0.5 bg-purple-100 text-purple-700 rounded">Add-on</span>
                                    )}
                                  </div>
                                  <span className="text-sm text-gray-600">${displayPrice.toFixed(2)}</span>
                                </button>
                              );
                            });
                          })()}
                        </div>
                      )}
                      
                      {newPackage.product_ids.length === 0 && !packageProductSearch && (
                        <p className="text-xs text-gray-500 mt-2">
                          Search and click products or add-ons to add them to this package
                        </p>
                      )}
                    </div>

                    {/* Price Calculation with Remove buttons */}
                    {newPackage.product_ids.length > 0 && (() => {
                      // Calculate total using tier pricing
                      const sqft = newPackage.square_footage || 2000;
                      let total = 0;
                      const selectedItems = [];
                      
                      // Get main products
                      products.filter(p => newPackage.product_ids.includes(p.id)).forEach(product => {
                        let price = product.price;
                        if (product.pricing_tiers && product.pricing_tiers.length > 0) {
                          const tier = product.pricing_tiers.find(t => 
                            sqft >= (t.min_sqft || 0) && sqft <= (t.max_sqft || Infinity)
                          );
                          if (tier) price = tier.price;
                        }
                        total += price;
                        selectedItems.push({ id: product.id, name: product.name, price, type: 'product' });
                      });
                      
                      // Get add-on products
                      addonProducts.filter(a => newPackage.product_ids.includes(a.id)).forEach(addon => {
                        const price = addon.base_price;
                        total += price;
                        selectedItems.push({ id: addon.id, name: addon.name, price, type: 'addon' });
                      });
                      
                      const percentageDiscount = total * (newPackage.discount_percentage / 100);
                      const fixedDiscount = newPackage.discount_amount || 0;
                      const totalDiscount = percentageDiscount + fixedDiscount;
                      const finalPrice = Math.max(0, total - totalDiscount);
                      
                      return (
                        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 space-y-3">
                          {/* Individual Product/Add-on Prices with Remove buttons */}
                          <div className="space-y-2">
                            <div className="text-xs font-medium text-gray-500 uppercase mb-2">
                              Pricing for {(sqft || 2000).toLocaleString()} sqft
                            </div>
                            {selectedItems.map((item) => (
                              <div key={item.id} className="flex justify-between items-center text-sm group">
                                <div className="flex items-center gap-2">
                                  <span className="text-gray-700">{item.name}</span>
                                  {item.type === 'addon' && (
                                    <span className="text-xs px-1 py-0.5 bg-purple-100 text-purple-700 rounded">Add-on</span>
                                  )}
                                </div>
                                <div className="flex items-center gap-2">
                                  <span className="text-gray-900 font-medium">${item.price.toFixed(2)}</span>
                                  <button
                                    type="button"
                                    onClick={() => setNewPackage({
                                      ...newPackage,
                                      product_ids: newPackage.product_ids.filter(id => id !== item.id)
                                    })}
                                    className="text-red-400 hover:text-red-600 p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                                  >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                          
                          <div className="pt-2 border-t border-gray-300">
                            <div className="flex justify-between items-center">
                              <span className="text-sm font-medium text-gray-700">Subtotal:</span>
                              <span className="text-lg font-semibold text-gray-900">
                                ${total.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          
                          {/* Discount Fields */}
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">Discount %</label>
                              <div className="flex items-center gap-1">
                                <input
                                  type="text"
                                  value={newPackage.discount_percentage || ''}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || !isNaN(value)) {
                                      const numValue = value === '' ? 0 : parseFloat(value);
                                      if (numValue >= 0 && numValue <= 100) {
                                        setNewPackage({...newPackage, discount_percentage: numValue});
                                      }
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const numValue = parseFloat(e.target.value) || 0;
                                    setNewPackage({...newPackage, discount_percentage: numValue});
                                  }}
                                  className="w-16 px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                                  placeholder="0"
                                />
                                <span className="text-gray-600 text-sm">%</span>
                              </div>
                              {newPackage.discount_percentage > 0 && (
                                <p className="text-xs text-green-600 mt-1">-${percentageDiscount.toFixed(2)}</p>
                              )}
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">Fixed Discount</label>
                              <div className="flex items-center gap-1">
                                <span className="text-gray-600 text-sm">$</span>
                                <input
                                  type="text"
                                  value={newPackage.discount_amount || ''}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || !isNaN(value)) {
                                      const numValue = value === '' ? 0 : parseFloat(value);
                                      if (numValue >= 0) {
                                        setNewPackage({...newPackage, discount_amount: numValue});
                                      }
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const numValue = parseFloat(e.target.value) || 0;
                                    setNewPackage({...newPackage, discount_amount: numValue});
                                  }}
                                  className="w-16 px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                                  placeholder="0"
                                />
                              </div>
                              {newPackage.discount_amount > 0 && (
                                <p className="text-xs text-green-600 mt-1">-${fixedDiscount.toFixed(2)}</p>
                              )}
                            </div>
                          </div>
                          
                          <div className="pt-3 border-t border-gray-300">
                            <div className="flex justify-between items-center">
                              <span className="text-base font-semibold text-gray-900">Package Price:</span>
                              <span className="text-2xl font-bold text-green-600">
                                ${finalPrice.toFixed(2)}
                              </span>
                            </div>
                            {totalDiscount > 0 && (
                              <p className="text-xs text-gray-500 text-right mt-1">
                                Total savings: ${totalDiscount.toFixed(2)}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-3 pt-6 mt-6 border-t">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddPackage(false);
                      setEditingPackage(null);
                      setNewPackage({ name: '', description: '', product_ids: [], discount_percentage: 0, discount_amount: 0, square_footage: 2000, image: null, image_id: null, active: false });
                    }}
                    className="flex-1 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={!newPackage.name || newPackage.product_ids.length === 0 || uploadingProductImage}
                    className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg font-medium flex items-center justify-center gap-2"
                  >
                    {uploadingProductImage ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Uploading Image...
                      </>
                    ) : (editingPackage ? 'Update Package' : 'Create Package')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Add/Edit Add-on Product Modal */}
        {showAddAddon && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[150]"
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                setShowAddAddon(false);
                setEditingAddon(null);
                setNewAddon({ name: '', description: '', base_price: 0, duration_minutes: 0, linked_product_ids: [], image: null, image_id: null });
              }
            }}
            tabIndex={-1}
            ref={(el) => el && el.focus()}
          >
            <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="px-6 py-4 bg-gray-700 flex justify-between items-center sticky top-0">
                <h3 className="text-lg font-semibold text-white">
                  {editingAddon ? 'Edit Add-on Product' : 'Create Add-on Product'}
                </h3>
                <button
                  onClick={() => {
                    setShowAddAddon(false);
                    setEditingAddon(null);
                    setNewAddon({ name: '', description: '', base_price: 0, duration_minutes: 0, linked_product_ids: [], image: null, image_id: null });
                  }}
                  className="text-white hover:text-gray-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <form onSubmit={async (e) => {
                e.preventDefault();
                try {
                  let addonId = editingAddon?.id;
                  
                  if (editingAddon) {
                    await axios.put(`${API}/settings/addon-products/${editingAddon.id}`, {
                      name: newAddon.name,
                      description: newAddon.description,
                      base_price: parseFloat(newAddon.base_price) || 0,
                      duration_minutes: parseInt(newAddon.duration_minutes) || 0,
                      linked_product_ids: newAddon.linked_product_ids,
                      is_active: newAddon.active
                    });
                  } else {
                    const createResponse = await axios.post(`${API}/settings/addon-products`, {
                      name: newAddon.name,
                      description: newAddon.description,
                      base_price: parseFloat(newAddon.base_price) || 0,
                      duration_minutes: parseInt(newAddon.duration_minutes) || 0,
                      linked_product_ids: newAddon.linked_product_ids,
                      is_active: newAddon.active
                    });
                    addonId = createResponse.data.id;
                  }
                  
                  // Upload image if selected
                  if (newAddon.image && addonId) {
                    console.log('Uploading image for addon:', addonId, 'File:', newAddon.image);
                    setUploadingProductImage(true);
                    const formData = new FormData();
                    formData.append('file', newAddon.image);
                    try {
                      const uploadResponse = await axios.post(`${API}/settings/addon-products/${addonId}/upload-image`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                      });
                      console.log('Image upload response:', uploadResponse.data);
                    } catch (uploadError) {
                      console.error('Image upload failed:', uploadError);
                      showToast('Add-on saved but image upload failed: ' + (uploadError.response?.data?.detail || uploadError.message), 'error');
                    } finally {
                      setUploadingProductImage(false);
                    }
                  }
                  
                  const response = await axios.get(`${API}/settings/addon-products`);
                  setAddonProducts(response.data);
                  
                  showToast(editingAddon ? 'Add-on updated successfully!' : 'Add-on created successfully!', 'success');
                  setShowAddAddon(false);
                  setEditingAddon(null);
                  setNewAddon({ name: '', description: '', base_price: 0, duration_minutes: 0, linked_product_ids: [], image: null, image_id: null });
                } catch (error) {
                  console.error('Error saving add-on:', error);
                  setUploadingProductImage(false);
                  showToast('Failed to save add-on: ' + (error.response?.data?.detail || error.message), 'error');
                }
              }} className="p-6">
                
                {/* Two-column layout for desktop, single column for mobile */}
                <div className="flex flex-col lg:flex-row lg:gap-8 lg:items-stretch">
                  {/* Left Column - Form Fields */}
                  <div className="flex-1 space-y-6">
                    {/* Add-on Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Add-on Name *</label>
                      <input
                        type="text"
                        required
                        value={newAddon.name}
                        onChange={(e) => setNewAddon({...newAddon, name: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="e.g., Virtual Staging"
                      />
                    </div>

                    {/* Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                      <textarea
                        value={newAddon.description}
                        onChange={(e) => setNewAddon({...newAddon, description: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        rows="3"
                        placeholder="Brief description of this add-on service..."
                      />
                    </div>

                    {/* Price and Duration */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Price ($) *</label>
                        <input
                          type="number"
                          required
                          min="0"
                          step="0.01"
                          value={newAddon.base_price}
                          onChange={(e) => setNewAddon({...newAddon, base_price: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          placeholder="50.00"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Duration (minutes)</label>
                        <input
                          type="number"
                          min="0"
                          value={newAddon.duration_minutes}
                          onChange={(e) => setNewAddon({...newAddon, duration_minutes: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          placeholder="0"
                        />
                        <p className="text-xs text-gray-500 mt-1">Leave 0 if no extra time needed</p>
                      </div>
                    </div>

                    {/* Thumbnail Image */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Thumbnail Image</label>
                      {(newAddon.image || editingAddon?.image_id) && (
                        <div className="mb-3">
                          {newAddon.image ? (
                            <div className="flex items-start gap-3">
                              <img 
                                src={URL.createObjectURL(newAddon.image)} 
                                alt="Add-on preview" 
                                className="w-24 h-24 object-cover rounded-lg border border-gray-300"
                              />
                              <button
                                type="button"
                                onClick={() => setNewAddon({...newAddon, image: null})}
                                className="text-xs text-red-600 hover:text-red-700"
                              >
                                Remove
                              </button>
                            </div>
                          ) : editingAddon?.image_id ? (
                            <div className="flex items-start gap-3">
                              <AddonImage addonId={editingAddon.id} imageName="Current add-on" size="w-24 h-24 rounded-lg border border-gray-300" />
                              <span className="text-xs text-gray-500">Current image</span>
                            </div>
                          ) : null}
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            setNewAddon({...newAddon, image: e.target.files[0]});
                          }
                        }}
                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      />
                    </div>

                    {/* Active Toggle */}
                    <div>
                      <label className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-700">Active</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={newAddon.active}
                            onChange={(e) => setNewAddon({...newAddon, active: e.target.checked})}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </label>
                      <p className="text-xs text-gray-500 mt-1">
                        Inactive add-ons won't appear on the public order form
                      </p>
                    </div>
                  </div>

                  {/* Right Column - Available with Products (desktop) / Below on mobile */}
                  <div className="lg:w-80 mt-6 lg:mt-0 lg:flex lg:flex-col">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Available with Products
                    </label>
                    <p className="text-xs text-gray-500 mb-2">Select which products can include this add-on</p>
                    <div className="border border-gray-200 rounded-lg flex-1 overflow-y-auto lg:max-h-none max-h-72" style={{ minHeight: '200px' }}>
                      {products.length === 0 ? (
                        <p className="p-4 text-sm text-gray-500 text-center">No products available</p>
                      ) : (
                        products.map(product => (
                          <label key={product.id} className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0">
                            <input
                              type="checkbox"
                              checked={newAddon.linked_product_ids.includes(product.id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setNewAddon({...newAddon, linked_product_ids: [...newAddon.linked_product_ids, product.id]});
                                } else {
                                  setNewAddon({...newAddon, linked_product_ids: newAddon.linked_product_ids.filter(id => id !== product.id)});
                                }
                              }}
                              className="rounded border-gray-300 text-blue-400 focus:ring-blue-500 mr-3"
                            />
                            <div className="flex-1">
                              <span className="text-sm font-medium text-gray-900">{product.name}</span>
                              <span className="text-xs text-gray-500 ml-2">${product.price}</span>
                            </div>
                          </label>
                        ))
                      )}
                    </div>
                    {newAddon.linked_product_ids.length === 0 && (
                      <p className="text-xs text-amber-600 mt-2">
                        Tip: If no products are selected, this add-on will be available with all products.
                      </p>
                    )}
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex gap-3 pt-6 mt-6 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddAddon(false);
                      setEditingAddon(null);
                      setNewAddon({ name: '', description: '', base_price: 0, duration_minutes: 0, linked_product_ids: [], image: null, image_id: null, active: true });
                    }}
                    className="flex-1 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={!newAddon.name || newAddon.base_price < 0 || uploadingProductImage}
                    className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg font-medium flex items-center justify-center gap-2"
                  >
                    {uploadingProductImage ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Uploading Image...
                      </>
                    ) : (editingAddon ? 'Update Add-on' : 'Create Add-on')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
    </>
  );
};

export default ProductModals;
